import { IGetGovernmentQuery } from "../../lib/queries/__generated__/GetGovernmentQuery.generated";
import Footer from "../layout/Footer";
import Awards from "./Awards";
import GovernmentHelmet from "./GovernmentHelmet";
import Menu from "./Menu";
import Projects from "./Projects";
import Resources from "./Resources";
import Stack from "./Stack";
import Stories from "./Stories";
import Team from "./Team";

interface IGovernmentPageProps {
  government: NonNullable<IGetGovernmentQuery["government"]>;
}
export default function GovernmentPage({ government }: IGovernmentPageProps) {
  return (
    <div
      css={{
        display: "flex",
        flexDirection: "column",
        height: "100%"
      }}
    >
      <GovernmentHelmet government={government} />

      <Menu government={government} />

      {government.sharing.stories && (government.stories?.items || []).length > 0 && (
        <div
          css={{
            marginTop: 32
          }}
        >
          <Stories government={government} />
        </div>
      )}

      {government.sharing.projects && (government.projects?.items || []).length > 0 && (
        <div
          css={{
            marginTop: 32
          }}
        >
          <Projects government={government} />
        </div>
      )}

      {government.sharing.productStack && (government.products || []).length > 0 && (
        <div
          css={{
            marginTop: 32
          }}
        >
          <Stack government={government} />
        </div>
      )}

      {government.sharing.awards && government.awards.length > 0 && (
        <div
          css={{
            marginTop: 32
          }}
        >
          <Awards government={government} />
        </div>
      )}

      {government.sharing.resources && (government.resources || []).length > 0 && (
        <div
          css={{
            marginTop: 32
          }}
        >
          <Resources government={government} />
        </div>
      )}

      {government.sharing.team && government.members.length > 0 && (
        <div
          css={{
            marginTop: 32
          }}
        >
          <Team government={government} />
        </div>
      )}

      <div
        css={{
          marginTop: 64
        }}
      />

      <Footer />
    </div>
  );
}
